/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_EnableInputs */



/**
* | output |
* | --- |
* | "Enable visual watermark" |
*
* @param {Options_Watermark_EnableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_enable = /** @type {((inputs?: Options_Watermark_EnableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_EnableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Activer le filigrane visuel")
	if (locale === "de") return /** @type {LocalizedString} */ ("Visuelles Wasserzeichen aktivieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Abilita filigrana visiva")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Включить визуальный водяной знак")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activar marca de agua visual")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("启用可视水印")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ビジュアルウォーターマークを有効にする")
	if (locale === "hi") return /** @type {LocalizedString} */ ("विज़ुअल वॉटरमार्क सक्षम करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ativar marca de água visual")
	return /** @type {LocalizedString} */ ("Enable visual watermark")
});